import React from 'react';
import { FiUser, FiUsers, FiUserPlus, FiInfo, FiStar } from 'react-icons/fi';

const DetailSidebar = ({ workOrder, customer, staff }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  return (
    <div className="lg:col-span-2 space-y-3">

      {/* CUSTOMER INFO */}
      <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
        <h3 className="text-base font-semibold text-[var(--text-primary)] mb-2 flex items-center space-x-2">
          <FiUsers size={16} />
          <span>Customer</span>
        </h3>
        
        {customer ? (
          <div className="space-y-1 text-sm">
            <p className="font-medium text-[var(--text-primary)]">{customer.name}</p>
            <p className="text-[var(--text-secondary)]">{customer.phone}</p>
            <p className="text-[var(--text-secondary)]">{customer.email}</p>
            <p className="text-[var(--text-secondary)]">{customer.address}</p>
            <div className="pt-1 border-t border-[var(--border-color)]">
              <p className="text-xs text-[var(--text-secondary)]">Total Orders</p>
              <p className="text-base font-semibold text-[var(--text-primary)]">{customer.totalOrders || 0}</p>
            </div>
          </div>
        ) : (
          <p className="text-[var(--text-secondary)]">Customer not found</p>
        )}
      </div>

      {/* STAFF INFO */}
      <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
        <h3 className="text-base font-semibold text-[var(--text-primary)] mb-2 flex items-center space-x-2">
          <FiUser size={16} />
          <span>Penanggung Jawab</span>
        </h3>
        
        {staff ? (
          <div className="space-y-1 text-sm">
            <p className="font-medium text-[var(--text-primary)]">{staff.name}</p>
            <p className="text-[var(--text-secondary)]">{staff.phone}</p>
            <p className="text-[var(--text-secondary)]">{staff.email}</p>
            <div className="flex flex-wrap gap-1 mt-1">
              {staff.skills?.map((skill, idx) => (
                <span key={idx} className="px-2 py-0.5 text-xs bg-blue-100 text-blue-800 rounded-full">
                  {skill}
                </span>
              ))}
            </div>
            <div className="pt-1 border-t border-[var(--border-color)]">
              <p className="text-xs text-[var(--text-secondary)]">Level</p>
              <p className="text-sm font-medium text-[var(--text-primary)]">{staff.level}</p>
            </div>
          </div>
        ) : (
          <p className="text-[var(--text-secondary)]">Staff not found</p>
        )}
      </div>

      {/* TEAM RINGKASAN */}
      {workOrder.team && workOrder.team.length > 0 && (
        <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
          <h3 className="text-base font-semibold text-[var(--text-primary)] mb-2 flex items-center space-x-2">
            <FiUserPlus size={16} />
            <span>Tim Pengerjaan</span>
            <span className="text-xs text-[var(--text-secondary)] ml-auto">
              {workOrder.team.length} orang
            </span>
          </h3>
          
          <div className="space-y-1.5">
            {workOrder.team.map((member, idx) => (
              <div key={idx} className="flex items-center justify-between text-sm">
                <div className="flex items-center gap-1.5">
                  {member.isLead && <FiStar size={12} className="text-yellow-500" />}
                  <span className="text-[var(--text-primary)] font-medium">{member.name}</span>
                </div>
                <div className="text-[var(--text-secondary)] text-xs">
                  {member.role || 'Anggota'} • {member.hours || 0}j
                </div>
              </div>
            ))}
            <div className="pt-1 border-t border-[var(--border-color)] text-xs text-[var(--text-secondary)]">
              Total estimasi: {workOrder.team.reduce((sum, m) => sum + (m.hours || 0), 0)} jam
            </div>
          </div>
        </div>
      )}

      {/* APPROVAL INFO */}
      <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
        <h3 className="text-base font-semibold text-[var(--text-primary)] mb-2">
          Persetujuan
        </h3>
        
        <div className="space-y-1 text-sm">
          <div className="flex justify-between">
            <span className="text-[var(--text-secondary)]">Metode</span>
            <span className="text-[var(--text-primary)] font-medium">
              {workOrder.approval?.method || '-'}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-[var(--text-secondary)]">Status</span>
            <span className={`font-medium ${
              workOrder.approval?.status === 'approved' ? 'text-green-600' :
              workOrder.approval?.status === 'rejected' ? 'text-red-600' :
              'text-yellow-600'
            }`}>
              {workOrder.approval?.status || 'pending'}
            </span>
          </div>
          {workOrder.approval?.date && (
            <div className="flex justify-between">
              <span className="text-[var(--text-secondary)]">Tanggal</span>
              <span className="text-[var(--text-primary)] font-medium">
                {new Date(workOrder.approval.date).toLocaleDateString('id-ID')}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* PAYMENT STATUS */}
      <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
        <h3 className="text-base font-semibold text-[var(--text-primary)] mb-2 flex items-center space-x-2">
          <span>Status Pembayaran</span>
        </h3>
        
        <div className="space-y-1 text-sm">
          <div className="flex justify-between items-center">
            <span className="text-[var(--text-secondary)]">Status</span>
            <span className={`text-sm font-semibold px-3 py-0.5 rounded-full ${
              workOrder.paymentStatus === 'paid' ? 'bg-green-100 text-green-700' :
              workOrder.paymentStatus === 'pending' ? 'bg-yellow-100 text-yellow-700' :
              workOrder.paymentStatus === 'failed' ? 'bg-red-100 text-red-700' :
              'bg-gray-100 text-gray-700'
            }`}>
              {workOrder.paymentStatus === 'paid' ? 'Lunas' :
               workOrder.paymentStatus === 'pending' ? 'Menunggu' :
               workOrder.paymentStatus === 'failed' ? 'Gagal' :
               'Unknown'}
            </span>
          </div>
          <div className="flex justify-between items-center border-t border-[var(--border-color)] pt-1 mt-1">
            <span className="text-[var(--text-secondary)]">Total WO</span>
            <span className="text-sm font-medium text-[var(--text-primary)]">
              {formatCurrency(workOrder.totalCost || 0)}
            </span>
          </div>
        </div>
      </div>

      {/* STATUS HISTORY */}
      {workOrder.history && workOrder.history.length > 0 && (
        <div className="bg-[var(--bg-primary)] p-4 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
          <h3 className="text-base font-semibold text-[var(--text-primary)] mb-2 flex items-center space-x-2">
            <FiInfo size={16} />
            <span>Status History</span>
            <span className="text-xs text-[var(--text-secondary)] ml-auto">
              {workOrder.history.length} changes
            </span>
          </h3>
          
          <div className="space-y-2 max-h-36 overflow-y-auto pr-1">
            {workOrder.history.map((item, index) => (
              <div key={item.id || index} className="relative pl-3 border-l-2 border-blue-400 text-sm">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-1">
                    <span className="text-xs font-medium text-[var(--text-primary)]">
                      {item.fromLabel}
                    </span>
                    <span className="text-[var(--text-secondary)]">→</span>
                    <span className="text-xs font-medium text-[var(--text-primary)]">
                      {item.toLabel}
                    </span>
                  </div>
                  <span className="text-[10px] text-[var(--text-secondary)]">
                    {new Date(item.timestamp).toLocaleString('id-ID', {
                      day: '2-digit',
                      month: 'short',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
                {item.note && (
                  <p className="text-xs text-[var(--text-secondary)] mt-0.5 italic">
                    "{item.note}"
                  </p>
                )}
                <p className="text-[10px] text-[var(--text-secondary)] mt-0.5">
                  by: {item.changedBy || 'System'}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailSidebar;